var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29.311,
    viewBox: "0 0 31.686 29.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-13.56 -342.865)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M34.186,17.4A11.893,11.893,0,0,1,32.7,23.162a14.19,14.19,0,0,1-12.534,7.131A14.81,14.81,0,0,1,13.9,28.928L4.5,31.811l3.134-8.648A11.893,11.893,0,0,1,6.149,17.4,12.833,12.833,0,0,1,13.9,5.866,14.81,14.81,0,0,1,20.168,4.5h.825c7.118.361,12.8,5.59,13.194,12.138Z",
    transform: "translate(10.06 339.365)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "BIDS",
    transform: "translate(21.369 360.52)",
    fontSize: 9,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2,
    y: 0
  }, "BIDS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBids);
export default __webpack_public_path__ + "static/media/bids.cbc0fde4e9ab9109ec199c8f83573f62.svg";
export { ForwardRef as ReactComponent };